import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState(localStorage.getItem("tl_company") || "");
  const [hubs, setHubs] = useState([]);
  const [selectedHub, setSelectedHubState] = useState(localStorage.getItem("tl_hub") || "");
  const [year, setYear] = useState(2026);
  const [theme, setTheme] = useState("dark");
  const [ready, setReady] = useState(false);

  const company = companies.find((c) => c.id === companyId) || null;

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  const reloadCompanies = useCallback(async () => {
    const { data } = await api.get("/companies");
    setCompanies(data);
    return data;
  }, []);

  const loadHubs = useCallback(async () => {
    const { data } = await api.get("/hubs");
    setHubs(data);
    setSelectedHubState((prev) => {
      const next = data.find((h) => h.id === prev) ? prev : (data[0]?.id || "");
      localStorage.setItem("tl_hub", next);
      return next;
    });
    return data;
  }, []);

  const setSelectedHub = useCallback((id) => { localStorage.setItem("tl_hub", id); setSelectedHubState(id); }, []);

  useEffect(() => {
    (async () => {
      let cs = await reloadCompanies();
      if (!cs || cs.length === 0) {
        await api.post("/seed");
        cs = await reloadCompanies();
      }
      setReady(true);
    })();
  }, [reloadCompanies]);

  useEffect(() => {
    if (companyId && companies.find((c) => c.id === companyId)) {
      loadHubs();
    }
  }, [companyId, companies, loadHubs]);

  const setCompany = (id) => { localStorage.setItem("tl_company", id); setCompanyId(id); };
  const clearCompany = () => { localStorage.removeItem("tl_company"); setCompanyId(""); setHubs([]); };

  const hubName = (id) => hubs.find((h) => h.id === id)?.name || "-";

  return (
    <AppContext.Provider
      value={{
        companies, company, companyId, setCompany, clearCompany, reloadCompanies,
        hubs, setHubs, loadHubs, selectedHub, setSelectedHub,
        year, setYear, theme, setTheme, ready, hubName,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
